import { supabase } from '@/utils/supabase';

export const ARTEMIS_OB_SYNC_REQUIRED_MESSAGE =
  "You don't have an Optimal Blue synced account yet. Please contact an admin to finish setup.";

export const ARTEMIS_ACCESS_VERIFY_ERROR_MESSAGE =
  'Could not verify Artemis access. Try again.';

export type ArtemisAccessStatus = 'allowed' | 'denied' | 'error';

export interface ArtemisAccessResult {
  status: ArtemisAccessStatus;
  error?: string;
}

export async function checkArtemisAccess(): Promise<ArtemisAccessResult> {
  const { data: sessionData, error: sessionError } = await supabase.auth.getSession();
  if (sessionError) {
    return {
      status: 'error',
      error: sessionError.message || 'Could not verify Artemis session'
    };
  }
  if (!sessionData.session) {
    return {
      status: 'error',
      error: 'Not authenticated'
    };
  }

  let allRecords;
  let obLinked;
  try {
    [allRecords, obLinked] = await Promise.all([
      supabase.rpc('can_view_all_artemis_records'),
      supabase.rpc('is_active_ob_linked_loan_officer')
    ]);
  } catch (error) {
    return {
      status: 'error',
      error: error instanceof Error ? error.message : 'Unknown Artemis access error'
    };
  }

  if (allRecords.error || obLinked.error) {
    return {
      status: 'error',
      error: allRecords.error?.message || obLinked.error?.message || 'Unknown Artemis access error'
    };
  }

  return {
    status: allRecords.data === true || obLinked.data === true ? 'allowed' : 'denied'
  };
}
